
const serverInformationUpdateInterval = 300000;
const serverInformationUpdateFirstTime = 5000;

export class ServerInformationService {
  constructor($http) {
    this.$http = $http;
    this.usage = null;
    this.scheduleUpdate(serverInformationUpdateFirstTime);
  }

  update() {
    return this.$http.get('/analytics/server-information')
      .then((result) => {
        this.databaseUsage = result.data.databaseUsage;
        this.databasePath = result.data.databasePath;
        this.databaseAlarm = result.data.databaseAlarm;
        this.hddUsage = result.data.hddUsage;
        this.hddAlarm = result.data.hddAlarm;
        this.hddHardLimit = result.data.hddHardLimit;
      })
      .catch((err) => {
        console.error(err);
      })
      .then(() => {
        this.scheduleUpdate();
      })
      ;
  }

  scheduleUpdate(timeout) {
    setTimeout(() => this.update(), timeout || serverInformationUpdateInterval);
  }
}



// WEBPACK FOOTER //
// ./src/core/server-information.service.js